import React, { useState } from "react";
import SignUpForm from "./SignUpForm";
import LoginForm from "./LoginForm";

export default function AuthPage() {
  const [mode, setMode] = useState("login"); // "login" | "signup"

  return (
    <div className="mx-auto max-w-md p-6">
      <div className="mb-4 flex gap-2">
        <button
          onClick={() => setMode("login")}
          className={`rounded px-3 py-2 ${mode === "login" ? "bg-black text-white" : "border"}`}
        >
          Log In
        </button>
        <button
          onClick={() => setMode("signup")}
          className={`rounded px-3 py-2 ${mode === "signup" ? "bg-black text-white" : "border"}`}
        >
          Sign Up
        </button>
      </div>

      {mode === "login" ? (
        <LoginForm onSuccess={() => {/* e.g., navigate or close modal */}} />
      ) : (
        <SignUpForm onSuccess={() => {/* e.g., navigate or close modal */}} />
      )}
    </div>
  );
}
